export default __webpack_public_path__ + "static/media/placement-redo-icon.351cdbbf.svg";